import { AxiosInstance } from 'axios';
import { EDeletionCmd, TDeletionAccountResponse } from 'types/deleteAcount';

export const helperMemberDevApi = (axios: AxiosInstance, url: string) => ({
  deleteMember: (): Promise<TDeletionAccountResponse> => {
    return axios.post(url, { cmd: EDeletionCmd.deleteMember });
  },
});
